import React from "react";
import profileEditable from "../../../../assets/img/custom/profileEditableNotice.jpg";

const NoticeCard = () => {
  return (
    <div className="saas-card">
      <div className="card-header-saas">
        <h3>Important Notice</h3>
      </div>
      
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "16px", justifyContent: "space-between" }}>
        <div className="notice-banner">
          <i className="fas fa-exclamation-triangle"></i>
          <div className="notice-content">
            <h4>Attention Athlete</h4>
            <p>
              If you <span>TRANSFER SCHOOLS</span>, you can keep your <span>SAME ACCOUNT</span>. Just click <span>EDIT</span> at the top of your profile address section & make changes.
            </p>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <img
            src={profileEditable}
            alt="Profile Editable Notice"
            style={{ maxWidth: "240px", width: "100%", height: "auto", borderRadius: "8px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default NoticeCard;
